import React from 'react'
import { Box } from 'rebass/styled-components'
import FeaturedDesktop from '../submodules/FeaturedDesktop'
import FeaturedMobile from '../submodules/FeaturedMobile'

const Featured = ({ firstModule, options, data }) => {
    return (
        <Box>
            <Box sx={{
                display: ['none', 'none', 'none', 'none', 'block'],
            }}>
                <FeaturedDesktop options={options} firstModule={firstModule} data={data} />
            </Box>
            <Box sx={{
                display: ['block', 'block', 'block', 'block', 'none'],
            }}>
                <FeaturedMobile options={options} firstModule={firstModule} data={data} />
            </Box>
        </Box>
    )
}

export default Featured
